/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosInstance } from "axios";
import { Result } from "../../../Shared/Protocol/protocol-result";

export class OrderPaymentsApiRemoteService {
  constructor(private service: AxiosInstance) {}

  public reprocess = async (orderId: string): Promise<Result<void>> => {
    try {
        const response = await this.service.post(`/order-payments/re-process-order-payment/${orderId}`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

}
